export default __webpack_public_path__ + "static/media/2025 Scanned MINUTES ANNUAL SHAREHOLDERS MTG 4.11.25.87a4b0b9.pdf";